import { render, staticRenderFns } from "./activityRecord.vue?vue&type=template&id=cb2093c4&scoped=true&"
import script from "./activityRecord.vue?vue&type=script&lang=js&"
export * from "./activityRecord.vue?vue&type=script&lang=js&"
import style0 from "./activityRecord.vue?vue&type=style&index=0&id=cb2093c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2093c4",
  null
  
)

export default component.exports